import { DateTime } from "ts-luxon";
import z from "zod";

export class ZodSchemas {
  static get all() {
    return z.object({
      Amount: this.amount,
      Balance: this.balance,
      CardIdentifier: this.sku,
      CardNumber: this.cardNumber,
      CardPin: this.pin,
      ConfigurationID: this.configurationID,
      CurrencyID: this.currencyID,
      IsSuccess: this.isSuccess,
      OrderID: this.orderID,
      OrganizationUnitID: this.organizationUnitID,
      Pin: this.pin,
      TransactionDate: this.transactionDate,
      TransactionID: this.transactionId,
    });
  }

  static get amount() {
    return z.number().min(0).max(999).multipleOf(0.01);
  }

  static get balance() {
    return z.number().multipleOf(0.01);
  }

  static get cardNumber() {
    return z
      .string()
      .trim()
      .min(1, "error.giftcardCodeRequired")
      .min(ZodSchemas.codeMinlength, "error.giftcardCodeMinlength")
      .max(ZodSchemas.codeMaxlength, "error.giftcardCodeMaxlength");
  }

  static get configurationID() {
    return z.number().min(1).multipleOf(1);
  }

  static get currencyID() {
    return z.string();
  }

  static get isSuccess() {
    return z.boolean();
  }

  static get orderID() {
    return z.number().min(1).multipleOf(1);
  }

  static get organizationUnitID() {
    return z.number().min(1).multipleOf(1);
  }

  static get pin() {
    return z
      .string()
      .trim()
      .min(1, "error.giftcardPinRequired")
      .min(ZodSchemas.pinMinlength, "error.giftcardPinMinlength")
      .max(ZodSchemas.pinMaxlength, "error.giftcardPinMaxlength");
  }

  static get sku() {
    return z.string().min(1, "error.skuRequired");
  }

  static get transactionDate() {
    return z.coerce
      .date()
      .max(DateTime.now().endOf("day").toJSDate())
      .transform((date) => DateTime.fromJSDate(date).toISODate() as string);
  }

  static get transactionId() {
    return z.string().min(1, "error.giftcardTransactionIdRequired");
  }

  static readonly codeMinlength: number = 13;
  static readonly codeMaxlength: number = 20;
  static readonly pinMinlength: number = 4;
  static readonly pinMaxlength: number = 5;

  static parseLiteral(expected: string, value: string): asserts value is typeof expected {
    z.literal(expected).parse(value);
  }
}
